import type { Slug } from "@/modules/jobSearchPrefiltered/types"
import type { FunctionComponent } from "react"

import { Text, TEXT_TYPES, TEXT_WEIGHTS } from "@jobteaser/ui-kit/components/Text/Text"

import { useTranslation } from "@/modules/i18n/components/useTranslation"
import { PREFILTERED_BASENAME } from "@/modules/jobSearchPrefiltered/constants"
import { getLocalizedContentKeysForSlug } from "@/modules/jobSearchPrefiltered/utils/getLocalizedContentKeysForSlug"
import { useLocale } from "@/modules/locales/useLocale"
import { Link } from "@/modules/routing/components/Link"

import styles from "./Tag.module.css"

export type NetlinkingBlockProps = {
  slug: Slug
}

export const Tag: FunctionComponent<NetlinkingBlockProps> = ({ slug }) => {
  const locale = useLocale()
  const { t } = useTranslation(["job_search_prefiltered"])
  const { title } = getLocalizedContentKeysForSlug(slug)
  const titleTranslation = t(title, slug.params)

  return (
    <Link
      className={styles.tag}
      href={`/${locale}/${PREFILTERED_BASENAME}/${slug.slug}`}
      key={slug.slug}
      data-testid="PrefilteredJobSearch-NetlinkingBlock__internalLink"
    >
      <Text
        type={TEXT_TYPES.SMALL}
        weight={TEXT_WEIGHTS.MEDIUM}
        resetSpacing
        className={styles.label}
        title={titleTranslation}
      >
        {titleTranslation}
      </Text>
    </Link>
  )
}
